import { useAuth } from "@/modules/auth/store/use-auth"
import { api } from "@/services/api"
import { useMutation } from "@tanstack/react-query"

interface LoginValues {
  email: string
  password: string
}

export default function useLogin() {
  const { logIn } = useAuth()
  const mutation = useMutation({
    mutationKey: ["use-login"],
    mutationFn: async (data: LoginValues) => api.cronos.auth.login.logIn(data),
    onSuccess: ({ data }) => logIn(data.description),
  })

  return mutation
}
